import { type CultureMapItem, CultureMapItemModel } from './culture-map-item.model';

export type CultureMapFacilityItem = CultureMapItem & {
    locationDescription?: string;

    phone: string;
    email: string;
    fax?: string;
    weblink?: string;
};

export class CultureMapFacilityItemModel extends CultureMapItemModel {
    public locationDescription?: string;

    public phone: string;
    public email: string;
    public fax?: string;
    public weblink?: string;

    constructor(mapItem: CultureMapFacilityItem) {
        super(mapItem);

        this.locationDescription = mapItem.locationDescription;

        this.phone = mapItem.phone;
        this.email = mapItem.email;
        this.fax = mapItem.fax;
        this.weblink = mapItem.weblink;
    }
}
